/**
 * OwnYou Color Palette — Sprint 14 Production Design System
 *
 * Complete color system for the OwnYou consumer application.
 * Light-blue primary palette matching Figma mockups, with Ikigai dimension colors.
 *
 * @see Figma_assets/iOS/ for visual reference
 */
/**
 * Legacy indigo palette — kept for backward compatibility
 */
export const primary = {
    50: '#EEF2FF',
    100: '#E0E7FF',
    200: '#C7D2FE',
    300: '#A5B4FC',
    400: '#818CF8',
    500: '#6366F1',
    600: '#4F46E5',
    700: '#4338CA',
    800: '#3730A3',
    900: '#312E81',
};
/**
 * OwnYou brand palette — Sky blue scale for dark mode
 */
export const ownyou = {
    50: '#F0F9FF',
    100: '#E0F2FE',
    200: '#BAE6FD',
    300: '#7DD3FC',
    400: '#38BDF8',
    500: '#0EA5E9',
    600: '#0284C7',
    700: '#0369A1',
    800: '#075985',
    900: '#0C4A6E',
};
/**
 * Surface colors — dark mode backgrounds and card fills
 */
export const surface = {
    background: '#0F172A',
    card: '#1E293B',
    cardAlt: '#334155',
    basket: '#10B981',
};
/**
 * Ikigai dimension colors — each dimension has a unique, recognizable hue
 */
export const ikigaiColors = {
    passion: { base: '#E11D48', light: '#FFF1F2', dark: '#9F1239' },
    mission: { base: '#7C3AED', light: '#F5F3FF', dark: '#5B21B6' },
    profession: { base: '#0891B2', light: '#ECFEFF', dark: '#155E75' },
    vocation: { base: '#059669', light: '#ECFDF5', dark: '#065F46' },
};
/**
 * Semantic colors
 */
export const semantic = {
    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444',
    info: '#3B82F6',
};
/**
 * Neutral scale — surfaces, text, borders
 */
export const neutral = {
    0: '#FFFFFF',
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
};
/**
 * Brand / third-party login colors
 */
export const brandColors = {
    microsoft: '#2f2f2f',
    apple: '#000000',
    google: '#4285F4',
};
/**
 * Combined color export for convenience
 */
export const colors = {
    primary,
    ownyou,
    surface,
    ikigai: ikigaiColors,
    ...semantic,
    neutral,
    brand: brandColors,
};
/**
 * CSS custom property tokens for ThemeProvider injection
 */
export const colorTokens = {
    '--color-primary': ownyou[400],
    '--color-primary-light': ownyou[200],
    '--color-primary-dark': ownyou[700],
    '--color-ownyou': ownyou[400],
    '--color-success': semantic.success,
    '--color-warning': semantic.warning,
    '--color-error': semantic.error,
    '--color-info': semantic.info,
    '--color-bg': surface.background,
    '--color-bg-subtle': '#1E293B',
    '--color-border': '#334155',
    '--color-text': '#F1F5F9',
    '--color-text-muted': '#94A3B8',
    '--color-card-bg': surface.card,
    '--color-card-bg-alt': surface.cardAlt,
    '--color-passion': ikigaiColors.passion.base,
    '--color-mission': ikigaiColors.mission.base,
    '--color-profession': ikigaiColors.profession.base,
    '--color-vocation': ikigaiColors.vocation.base,
};
//# sourceMappingURL=colors.js.map